import React from 'react';

export default ({ className }) => (
  <div {...{ className }} />
);
